<template>
    <CoverImage :src="src">
        <slot v-if="content" v-bind="{ content, iconClass }">
            <div class="absolute right-2 bottom-2 text-white leading-none">
                <i :class="iconClass" />
            </div>
        </slot>
    </CoverImage>
</template>

<style lang="less" type="text/less"></style>

<script type="text/babel">
import CoverImage from 'dashboard-js/components/utilities/CoverImage'

export default {
    components: { CoverImage },

    props: ['content'],

    computed: {
        iconClass() {
            const icons = {
                video: 'fa fa-video-camera',
                video_story: 'fa fa-video-camera',
                carousel_album: 'fa fa-th-large',
            }

            return this.$get(icons, this.$get(this.content, 'content_type', '').toLowerCase())
        },

        src() {
            return this.$get(this.content, 'cached_media_image') || this.$get(this.content, 'media_image')
        },
    },
}
</script>
